module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component.css
// module id = ./src/app/Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component.css
// module chunks = main